import React from 'react';
import { ArrowRightIcon } from "../Icon";
import BodyText from "../Typography/texts/BodyText";
import HeadingSmall from "../Typography/titles/HeadingSmall";
import styles from './CTABanner.module.scss';
const CTABanner = ({ heading, onClick, text }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("button", { className: styles.button, onClick: onClick, type: "button", id: "CTABanner" },
            (heading || text) && (React.createElement("span", { className: styles.textWrapper },
                heading && (React.createElement(HeadingSmall, { marginless: true, Tag: "span", htmlFor: "CTABanner" }, heading)),
                text && React.createElement(BodyText, { Tag: "span" }, text))),
            React.createElement(ArrowRightIcon, null))));
};
export default CTABanner;
//# sourceMappingURL=CTABanner.js.map